import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { mapboxV6 } from "@circle-react/helpers/urlHelpers/internalApi/mapboxV6";

const token = () => reactQueryPost(mapboxV6.token());

export const mapboxV6Api = {
  token,
};
